import React, { useEffect, useRef, useState } from 'react';
import { View, Text, TextInput, ScrollView } from 'react-native';

import Modal from 'react-native-modal';
import disableScroll from "disable-scroll";

import { PrimaryCTA } from '../widgets/CommonCTA';
import { CloseIcon, VerticalDivider } from '../widgets/Common-Widget';

import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';

const CartQuantityInputBottomSheet = (props) => {
    const showModal = props.showModal
    const qtyInputRef = useRef<TextInput>(null);
    const selectedProductData = props.selectedProductData

    const closeModal = props.closeModal
    const primaryAction = props.primaryAction

    const [stripList, setStripList] = useState([])
    const [productQty, setProductQty] = useState('')

    function getStripTypes(product) {
        if (product?.mmid) {
            let stripList: any = [];
            for (let i: number = 1; i <= 3; i++) {
                let stripObj = {
                    su: product.su * i,
                    stripCount: `(${i} ${product.form})`,
                    dfPlural: product.dfPlural
                }
                stripList.push(stripObj)
            }
            disableScroll.off()
            setStripList(stripList)
        }
    }

    useEffect(() => {
        getStripTypes(selectedProductData)
    }, [])

    return <Modal key={'Quantity Input'}
        isVisible={showModal} hasBackdrop={true}
        deviceHeight={AppTheme.modalHeight}
        backdropOpacity={AppTheme.modalBackdropOpacity}
        animationOutTiming={AppTheme.modalAnimationDuration}
        style={[AppStyles.alignCenter, { marginBottom: 0 }]}
        onBackdropPress={() => closeModal()}>
        <View style={[AppStyles.bottomFix, AppStyles.topBorderView, {
            width: AppTheme.appWidth, padding: 16, margin: "auto"
        }]}>

            <View style={[AppStyles.flexRowSpaceBetween]}>
                <Text style={[TextStyle.text20b]}>
                    {selectedProductData?.['mmid'] ?
                        'Enter Quantity' : 'Add Item'}</Text>
                <CloseIcon action={() => closeModal()} />
            </View>

            <View style={[AppStyles.flexRow, AppStyles.mY16, AppStyles.px12,
            AppStyles.py8, AppStyles.borderView, AppStyles.bgWhite, { width: AppTheme.appWidth - 32 - 24 }]}>
                <TextInput maxLength={4} value={productQty} ref={qtyInputRef}
                    autoFocus={true} autoCorrect={false} autoComplete={"off"}
                    blurOnSubmit={false} keyboardType="numeric" importantForAutofill={"no"}
                    placeholder="Input number" placeholderTextColor={AppTheme.color.grey.text}
                    onChangeText={(value) => { setProductQty(value.replace(/[^0-9]/g, '')) }}
                    style={[TextStyle.text14b, { flex: 6 }]} />
                <View style={[AppStyles.flexRowEnd, { flex: 4 }]}>
                    <VerticalDivider height={24} marginHorizontal={8} />
                    <Text style={[TextStyle.text14, { color: AppTheme.color.grey.text }]}>
                        {selectedProductData?.dfPlural ?? 'Items'}</Text></View>
            </View>

            {!!stripList.length && <ScrollView
                horizontal={true} showsHorizontalScrollIndicator={false}
                keyboardShouldPersistTaps="always" keyboardDismissMode="none"
                style={[{ paddingTop: 8, paddingBottom: 32 }]}>
                {stripList.map((item, i) => <Text key={i}
                    onPress={() => { qtyInputRef.current.focus(); setProductQty(item.su); }}
                    style={[TextStyle.text14, {
                        color: productQty == item.su ?
                            AppTheme.color.primary : AppTheme.color.grey.text,
                        backgroundColor: productQty == item.su ?
                            AppTheme.color.blue.bg : AppTheme.color.background,
                        marginRight: 8, padding: 8, borderRadius: 24
                    }]}>{item.su} {item.dfPlural} {item.stripCount}</Text>)}
            </ScrollView>}

            <PrimaryCTA text={'Done'} onPress={() => {
                closeModal(); primaryAction(selectedProductData, parseInt(productQty))
            }} disabled={!productQty || parseInt(productQty) == 0} />

        </View>
    </Modal>
}

export default CartQuantityInputBottomSheet